import { render, staticRenderFns } from "./method-selection-card.vue?vue&type=template&id=1f93b49e&scoped=true"
import script from "./method-selection-card.vue?vue&type=script&lang=ts"
export * from "./method-selection-card.vue?vue&type=script&lang=ts"
import style0 from "./method-selection-card.vue?vue&type=style&index=0&id=1f93b49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93b49e",
  null
  
)

export default component.exports